import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { BankingSDK as BankingSDKComponent } from "ui/organizms/OpenBanking";

const BankingSDK = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Banking SDK'
    >
        <BankingSDKComponent />
    </Screen>

);

export default memo(BankingSDK);
